module.exports = __webpack_public_path__ + "assets/images/checkmark.7eefe40ad76aff254bf3d8be8143e74a.svg";